import * as actionTypes from "actions";
const userInitialState = {
  loading: false,
  currentMedication: [],
  error: "",
};

const currentMedicationReducer = (state = userInitialState,  action) => {
  switch (action.type) {
    case actionTypes.FETCH_CURRENTMEDICATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.FETCH_CURRENTMEDICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        currentMedication: action.payload,
        error: "",
      };
    case actionTypes.FETCH_CURRENTMEDICATION_FAILURE:
      return {
        ...state,
        loading: false,
        currentMedication: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default currentMedicationReducer;
